module.exports = __webpack_public_path__ + "img/teacher-t.00b22a64.png";